import { createContext } from 'react';
const ViewContainerContext = /*#__PURE__*/createContext({});
export default ViewContainerContext;